import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import partnerList from '../../../Management/partner/partner.List.i18n'
import groupList from '../../../Management/group/group.List.i18n'
import { Switch as cSwitch } from '@coreui/vue';
import VueMonthlyPicker from 'vue-monthly-picker'

//restful api
import { partner as billing } from '@/service/api/billing';
import { license } from '@/service/api/billing';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', sortable: true, label: '#.' },
    { key: 'apply_date', thStyle: 'width: 10%', sortable: true, label: 'Date'},
    { key: 'partner', thStyle: 'width: 30%', sortable: false, label: 'Partner' },
    { key: 'price', thStyle: 'width: 10%', sortable: false, label: 'Price' },
    { key: 'status', thStyle: 'width: 15%', sortable: false, label: 'Payment confirmation' },
    { key: 'func', sortable: false, label: 'More' },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', sortable: true, label: '#.' },
    { key: 'apply_date', thStyle: 'width: 10%', sortable: true, label: '날짜'},
    { key: 'partner', thStyle: 'width: 30%', sortable: false, label: '파트너' },
    { key: 'price', thStyle: 'width: 10%', sortable: false, label: '가격' },
    { key: 'status', thStyle: 'width: 15%', sortable: false, label: '지불 확인' },
    { key: 'func', sortable: false, label: '더보기' },
  ]
}

export default {
  components: { DatePicker, vSelect, partnerList, groupList, cSwitch, VueMonthlyPicker },
  props : ["auto_refresh", "enable_new", "view_detail", 'partner_id'],
  name : "InvoiceList",
  data: () => ({
    service : {},
    service_list : [],
    partner_service : [],
    modal_new : false,
    confirm_payment_history : false,
    payment_history : '',
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total_paid : 0, paid : 0, not_paid : 0 },  //paid : 지불 , not_paid : 미지불 으로 변수명 변경하였습니다.
    invoice : { amount : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    nbsp : "\u00A0",
    hide_del : true,
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    },
  },
  methods: {
    bill(invoice_id) {
      let url = "https://www.sandbox.paypal.com/invoice/s/pay/"
      if(location.hostname != 'localhost' && location.hostname != '10.20.0.4') { url = url.replace('sandbox', '') }
      console.log("result", url + invoice_id)
      window.open(`${url}${invoice_id}`);
    },
    remove_service(x) {
      console.log(x)
      this.service_list.splice(x, 1)
      // this.service_list = this.service_list.length ?  : []
    },
    set_service:function(x) {
      if(!this.service || !this.service.service_name) { return this.$toastr.e("required service") }
      let service = JSON.parse(JSON.stringify(this.service))
      this.service_list.push(service)

      this.invoice.amount += Number(service.amount)

      this.service.usage = 0
      this.service.amount = 0
      this.service.partner_price = 0
    },
    load_partner_service() {
      try{
       let partner_service_info = {
          // target : 'partner.license', cmd : 'list',
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '=' }, { name : 'is_alive', value : true, op : '=' }, { name : 'partner_id', value : this.invoice.partner_id, op : '=' }] }
        }
        // Api.Manager(partner_service_info).then(rs => {
          license.listLicense(partner_service_info).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }

          rs.body.forEach(x => {
            if(!x.is_publish) {
              return console.log('not puglished', x.service_name)
            }
            this.partner_service.push({ id : x.id, customer_price : x.customer_price, partner_price : x.partner_price, service_name : x.service_name })

          })

        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
      } catch(e) { console.log(e); this.$toastr.e(e.data.message, e.status, e.statusText); }
    },
    //TODO : insertPartner 로 api 요청하며 나중에 강제로 청구서 발행할때 필요한 기능
    new_invoice() {
      if(!this.invoice.month && (!this.invoice.start_at || !this.invoice.end_at)) { return this.$toastr.w("plz, select date")  }
      else if(moment(this.invoice.month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      }

      console.log(this.invoice.month ? this.invoice.month.format("yyyy-MM-DD") : '')
      this.invoice.month = this.invoice.month ? this.invoice.month.format("yyyy-MM-DD") : ''
      this.invoice.start_at = this.invoice.start_at ? moment(this.invoice.start_at).format("yyyy-MM-DD") : ''
      this.invoice.end_at = this.invoice.end_at ? moment(this.invoice.end_at).format("yyyy-MM-DD") : ''

      // Api.Manager({ target : 'invoice.partner', cmd : 'create', body : Object.assign({}, this.invoice, { service_list : this.service_list })})
      billing.insertPartner(Object.assign({}, this.invoice, { service_list : this.service_list }))
        .then(rs => {
          console.log("result", rs.body)
          window.open(rs.body);
        })
        .catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
        });
    },
    change_failed($event) { if($event == true || $event == false) { this.so.opt['is_failed'] = $event; this.refresh(); } },
    change_done($event) { if($event == true || $event == false) { this.so.opt['is_paid'] = $event; this.refresh(); } },
    change_refunded($event) { if($event == true || $event == false) { this.so.opt['is_refunded'] = $event; this.refresh(); } },
    modal_history(history) {
      this.payment_history = history.map(r => typeof r == typeof 'string' ? JSON.parse(r) : r)
      this.confirm_payment_history = true;

      console.log("payment history load", history.length)
    },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.invoice.partner_username = this.so.opt['partner_username'] = item.username
      this.invoice.partner_id = this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.load_partner_service()
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.opt.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['paid_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['refund_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.partner_name = ''; this.refresh(); },
    refresh() { if(!this.loading) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      this.loading = true;
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && this.so.sv) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.partner_id) { so.body.and.push({ name : 'partner_id', value : this.partner_id, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'paid_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 7), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 7), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'paid_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 7), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 7), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            case 'refund_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 9), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'refund_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 9), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return billing.listPartner(so).then(rs => {
        if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
        this.loading = false; this.so.totalRows = rs.total; return rs.body;
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      billing.summary(Object.assign({}, { params : { id : this.partner_id, ts : new Date().getTime() }} ))
        .then(rs => { this.model = Object.assign(this.model, { paid : rs.body.total_paid, not_paid : rs.body.not_paid, total_paid : (rs.body.total_paid + rs.body.not_paid) }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail(item) {
      if(this.view_detail === false) { this.$root.$emit("select", item); }
      else { this.$router.push({ name : 'InvoicePartner', params : { id : item.id } }); }
    },
  },
  created() { console.log('invoice.partner.List.vue', 'created'); },
  destroyed() { console.log('invoice.partner.List.vue', 'destroyed'); },
  mounted() {
    console.log('invoice.partner.List.vue', 'mounted');
    this.$root.$on('selected', this.setPartner);
    this.$root.$on('select', this.setGroup);
  },
}